module.exports = __webpack_public_path__ + "static/media/prd-cat-md-1.b3023faf.jpg";